<h3 class="my-4 text-uppercase">
  {{ title | translate }} ({{ (data ? data.length : 0) | number: DIGITS_REPRESENTATION_OPTIONS }})
</h3>

<div
  class=""
  [ngClass]="currentLayout === layoutsResult.MOBILE ? 'carousel-holder-mobile mb-5' : 'carousel-holder mb-5'"
  *ngIf="data"
>
  <button
    *ngIf="showButton"
    data-test-id="slick-prev-btn"
    (click)="slickCarousel.slickPrev()"
    type="button"
    class="page-link-prev"
  >
    &lt;
  </button>
  <ngx-slick-carousel
    [ngClass]="currentLayout === layoutsResult.MOBILE ? 'carousel-mobile' : 'carousel'"
    #slickCarousel="slick-carousel"
    [config]="slideConfig"
  >
    <div
      ngxSlickItem
      *ngFor="let slide of data; index as i"
      [ngClass]="currentLayout === layoutsResult.MOBILE ? 'slide-mobile' : 'slide'"
    >
      <app-card [data]="slide" [index]="i" [type]="cardType"> </app-card>
    </div>
  </ngx-slick-carousel>
  <button
    *ngIf="showButton"
    data-test-id="slick-next-btn"
    (click)="slickCarousel.slickNext()"
    type="button"
    class="page-link"
  >
    &gt;
  </button>
</div>
